class AddTileset {
  constructor() {
    this.containers = [];
    this.show = true;
  }
  addTileset(config) {
    const palaceTileset = new Cesium.Cesium3DTileset({
      url: config.url,
      maximumScreenSpaceError: 1,
      maximumNumberOfLoadedTiles: 100000
    });
    palaceTileset.id = config.id;
    this.containers.push(
      map3d_viewer.viewer.scene.primitives.add(palaceTileset)
    );
    palaceTileset.readyPromise.then(msg => {
      let tempposition = Cesium.Cartographic.fromCartesian(
        msg.boundingSphere.center
      );
      var longitude = config.hasOwnProperty("lng")
        ? config.lng
        : (tempposition.longitude * 180) / Math.PI;
      var latitude = config.hasOwnProperty("lat")
        ? config.lat
        : (tempposition.latitude * 180) / Math.PI;
      var heightOffset = config.hasOwnProperty("height")
        ? config.height
        : tempposition.height;
      var boundingSphere = palaceTileset.boundingSphere;
      var cartographic = Cesium.Cartographic.fromCartesian(
        boundingSphere.center
      );
      var offsetvalue = Cesium.Cartographic.fromDegrees(
        longitude,
        latitude,
        heightOffset
      );
      var surface = Cesium.Cartesian3.fromRadians(
        cartographic.longitude,
        cartographic.latitude,
        0.0
      ); //模型改变的位置
      var offset = Cesium.Cartesian3.fromRadians(
        offsetvalue.longitude,
        offsetvalue.latitude,
        heightOffset
      ); //定义模型的改变状态
      var translation = Cesium.Cartesian3.subtract(
        offset,
        surface,
        new Cesium.Cartesian3()
      ); //修改模型的位置
      palaceTileset.modelMatrix = Cesium.Matrix4.fromTranslation(translation);
    });
    return palaceTileset;
  }
  getById(id) {
    let result;
    let index;
    this.containers.forEach((item, i) => {
      if (item.id === id) {
        result = item;
        index = i;
      }
    });
    return {
      tiles: result,
      index: index
    };
  }
  setShowById(id, show) {
    const { tiles } = this.getById(id);
    tiles.setShow(show);
  }
  removeTilesetById(id) {
    const { tiles, index } = this.getById(id);
    this.containers.splice(index, 1);
    tiles.destroy();
  }
  setShowAll(show) {
    if (this.containers.length > 0) {
      this.containers.forEach(item => {
        item.show = show;
      });
    }
  }
}
export default new AddTileset();



// WEBPACK FOOTER //
// ./src/mapfunction/Addtileset.js